<template>
  <button @click="onClick()" :class="size">{{ caption }}</button>
</template>

<script>
export default {
  props: {
    caption: String,
    size: String,
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped lang="scss">
button {
  border: none;
  outline: none;
  color: rgb(0, 0, 0);
  border: 2px solid #000;
  background-color: transparent;
  cursor: pointer;
  height: 55px;
  padding: 0 20px;
  text-transform: uppercase;
  transition: 0.2s;
  &:hover {
    background-color: #000;
    color: #fff;
  }
}
.xl {
  padding: 0 72px;
}
</style>
